import { ForgotPassword } from 'containers/Auth'

export default ForgotPassword
